import { handleActions } from 'redux-actions';
import * as fieldsConfigActions from '../actions/fieldsActions';

let filtersState = {
  responsibles: null,
  positionsRepresentatives: null,
  statuses: null,
};

export const fieldsConfig = handleActions(
  {
    [fieldsConfigActions.getPositionsRepresentatives]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getPositionsRepresentativesSuccess]: (
      state,
      action
    ) => {
      let { payload } = action;
      return {
        ...state,
        positionsRepresentatives: payload.data,
      };
    },
    [fieldsConfigActions.getPositionsRepresentativesError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        positionsRepresentatives: payload.message,
      };
    },
    [fieldsConfigActions.getCustomersStatuses]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getCustomersStatusesSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        statuses: payload.data,
      };
    },
    [fieldsConfigActions.getCustomersStatusesError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        statuses: payload.message,
      };
    },
    [fieldsConfigActions.getResponsibles]: (state, action) => {
      return state;
    },
    [fieldsConfigActions.getResponsiblesSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        responsibles: payload.data,
      };
    },
    [fieldsConfigActions.getResponsiblesError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        responsibles: payload.message,
      };
    },
  },
  filtersState
);
